import Vue from 'vue'
import Router from 'vue-router'
import Register from '@/components/Register'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Profile from '@/components/Profile'
import Kyc from '@/components/Kyc'
import firebase from 'firebase'


Vue.use(Router)

let router= new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/Profile',
      name: 'Profile',
      component: Profile,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/Kyc',
      name: 'Kyc',
      component: Kyc,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register,
      meta:{
        requiresGuest:true
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta:{
        requiresGuest:true
      }
    }

  ]
})

// Navigation Guards

router.beforeEach((to, from, next) => {

if (to.matched.some(record => record.meta.requiresAuth)){
if (!firebase.auth().currentUser){
  next({
    path:'/login',
    query:{
      redirect: to.fullPath
    }
  }
  );
} else {
  next();
}
} 

else if(to.matched.some(record => record.meta.requiresGuest)){
// vedo se l'utente è loggato
  if (firebase.auth().currentUser){
    next({
      path:'/',
      query:{
        redirect: to.fullPath
      }
    }
    );
  } else {
    next();
  }

} else {
next();
}
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js